var c = Object.defineProperty;
var h = (e, t, r) => t in e ? c(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r;
var o = (e, t, r) => (h(e, typeof t != "symbol" ? t + "" : t, r), r);
class d {
  constructor(t) {
    o(this, "forms", []);
    o(this, "spaceCustomization");
    this.spaceCustomization = t, this.forms = [];
  }
  process(t) {
    "text" in t || t.type !== "form" || this.forms.push(t);
  }
  getCustomization() {
    if (this.forms.length === 0)
      return {};
    const t = this.spaceCustomization;
    function r(i, n) {
      var u, m, a;
      const f = (a = (m = (u = t == null ? void 0 : t.form_reference) == null ? void 0 : u.content) == null ? void 0 : m[n.form_id]) == null ? void 0 : a.value;
      return f ? {
        ...i,
        [n.form_id]: {
          value: f,
          updated_at: new Date().toISOString()
        }
      } : i;
    }
    const s = this.forms.reduce(r, {});
    return {
      form_reference: {
        content: s,
        published_content: s
      }
    };
  }
}
export {
  d as FormExtractor
};
